<template>
    <div>
        <el-row type="flex" align="middle">
            <h2 style="text-align: center; flex: 1">机构学员分析</h2>
            <el-button type="primary" size="small"
                       @click.stop="handleDownload"
                       style="height: 32px" icon="el-icon-download">下载报告</el-button>
        </el-row>
        <div style="text-align: center" class="font-size16">
            机构拥有学员
            <span class="c-0C95FD font-weight font-size22">{{statData.TotalQty | toNum}}</span> 人，
            参与考试
            <span class="c-0C95FD font-weight font-size22">{{statData.JoinExamQty | toNum}}</span> 人，
            当年新增学员
            <span class="c-0C95FD font-weight font-size22">{{statData.AddQty | toNum}}</span> 人
        </div>
        <div class="xy-between" style="margin-top: 40px">
            <div class="analyse">
                <div class="font-size18 font-medium" style="margin-bottom: 25px">学员分析</div>
                <div class="org-student-org" style="margin-bottom: 20px">
                    <div class="xy-between font-size16" style="margin-bottom: 10px">机构学员总人数<span>{{statData.TotalQty | toNum}}人</span></div>
                    <el-progress :percentage="100"
                                 :stroke-width="12"
                                 stroke-linecap="butt"
                                 define-back-color="#FFF"
                                 color="#6699FF" :show-text="false"/>
                </div>
                <div class="org-student-org" style="margin-bottom: 20px">
                    <div class="xy-between font-size16" style="margin-bottom: 10px">当年新增机构学员<span>{{statData.AddQty | toNum}}人</span></div>
                    <el-progress :percentage="statData | getRatio('AddQty')"
                                 :stroke-width="12"
                                 define-back-color="#FFF"
                                 stroke-linecap="butt"
                                 color="#F7B44C" :show-text="false"/>
                </div>
                <div class="org-student-org"
                     style="margin-bottom: 20px">
                    <div class="xy-between font-size16"
                         style="margin-bottom: 10px">当年参与考试人数<span>{{statData.JoinExamQty | toNum}}人</span></div>
                    <el-progress :percentage="statData | getRatio('JoinExamQty')"
                                 :stroke-width="12"
                                 define-back-color="#FFF"
                                 stroke-linecap="butt"
                                 color="#5DD4AF" :show-text="false"/>
                </div>
            </div>
            <!-- 学员分组分析-->
            <div class="group-analyse">
                <div class="font-size18 font-medium xy-between">
                    <div>学员分组分析</div>
                    <div>分组学员参考人数分析</div>
                </div>
                <bar-chart :chart-data="statData.DeptDetails"
                           height="220px"
                           :options="groupOptions"
                           :dimensions="['OrganLevelName', 'Qty', 'JoinQty']"/>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultSeriesSettings as barSettings } from "@/components/Charts/BarChart/config";
import { defaultSeriesSettings as lineSettings } from "@/components/Charts/LineChart/config";
import { getStatStudentReport, exportStudentReport } from "@/api/manage"
import { downloadUrl } from "download.js";

export default {
    name: "GroupStudentAnalyse",
    data() {
        return {
            statData: {}
        }
    },
    computed: {
        getSeries() {
            return [
                Object.merge(barSettings(), {
                    name: "学员分组人数",
                    color: "#6699FF",
                    areaStyle: undefined,
                    label: {
                        fontSize: 14,
                        formatter: ["{Qty|{@Qty}}", "{JoinQty|{@JoinQty}人}"].join("/"),
                        rich: {
                            JoinQty: {
                                color: "#F7B44C",
                                fontSize: 14,
                            }
                        }
                    }
                }),
                Object.assign(lineSettings(), {
                    name: "当年参与考试人数",
                    color: "#F7B44C",
                    areaStyle: undefined
                })]
        },
        groupOptions ({ getSeries }) {
            return {
                series: getSeries,
                yAxis: [
                    {
                        type: "value",
                        minInterval: 1,
                        axisLabel: {
                            fontSize: 14
                        }
                    }
                ],
                title: {
                    text: ""
                },
            }
        }
    },
    created() {
        this.getStatStudentReport()
    },
    filters: {
        toNum (val) {
            return Number(val) ? Number(val) : 0
        },
        getRatio (val, key) {
            const { TotalQty = 0, [key]: qty = 0 } = Object.isObj(val) ? val : Object.create(null)
            return TotalQty === 0 ? 0 : parseFloat(((qty / TotalQty) * 100).toFixed(2))
        }
    },
    methods: {
        getStatStudentReport () {
            getStatStudentReport().then(res => {
                this.statData = res
            })
        },
        handleDownload () {
            exportStudentReport().then(res => {
                downloadUrl("机构学员分析", res)
            })
        }
    }
}
</script>

<style scoped lang="less">
.analyse {
    padding: 20px;
    box-sizing: border-box;
    width: 49%;
    border-radius: 5px;
    border: 2px solid #256CF4;
    height: 300px;
}
.group-analyse {
    padding: 20px;
    box-sizing: border-box;
    width: 49%;
    border-radius: 5px;
    border: 2px solid #256CF4;
    height: 300px;
}
</style>
